import React, { useEffect, useMemo, useState } from 'react';
import PageContainer from '../../components/PageContainer';
import MainContent from '../../components/MainContent';
import PageTitle from '../../components/Common/PageTitle/PageTitle';
import ActionDropdownItem from '../../components/Common/PageTitle/ActionDropdownItem';
import { useTheme } from '../../DataStore/ThemeContext';
import NexumPaySummaryCard from '../../components/Banking/NexumPaySummaryCard';
import MiniStatCard from '../../components/Banking/MiniStatCard';
import { useCurrency } from '../../util/SystemVariables';
import WalletRow from '../../components/NexumPay/WalletRow';
import { useWallet } from '../../DataStore/WalletContext';
import { numberFormat } from '../../util/araknerdlib';
import RecentTransactions from '../../components/NexumPay/RecentTransactions';
import Notification from '../../components/Common/Notification';

const NexumPayPage = () => {
  const { openSettings, setNotify } = useTheme();
  const {walletListing, getWallets} = useWallet();
  const currency = useCurrency();
  const [quickStats, setQuickStats] = useState(false);
  useEffect(() => {
    getWallets();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  

  /* actions */
  const handleNewWallet = () => {setNotify(<Notification type='info' message="Wallet connection is coming soon!" />);};
  const handleRefresh = () => {setNotify(<Notification type='info' message="Wallet connection is coming soon!" />);}; // wire to fetch
  const handleReconcile = () => {}; // wire to reconcile page
  const handleNewPayment = () => {setNotify(<Notification type='info' message="Wallet connection is coming soon!" />);}
  
  // bulk payouts quick actions
  const startBulkWizard = () => {
    setNotify(<Notification type='info' message="Bulk payouts coming soon!" />);
  }
  
  const PageActions = () => (
    <>
      <ActionDropdownItem iconClass="fa fa-link" label="Connect Wallet" onClick={handleNewWallet} />
      <ActionDropdownItem iconClass="fa fa-layer-group" label="Bulk Payouts" onClick={startBulkWizard} />
      <ActionDropdownItem iconClass="fa fa-sync" label="Refresh" onClick={handleRefresh} />
    </>
  );

  return (
    <PageContainer>
      <MainContent>
        <PageTitle
          title="NexumPay"
          description="Manage payment wallets, make single or bulk payouts, and automate reconciliation."
          iconClass="fa fa-wallet"
          PageActions={PageActions}
        />


          <div className="row">
          <div className="col-xl-8 mb-3">
            {/* Accounts card */}
            <WalletRow 
              isLoading={!walletListing}
              walletListing={walletListing}
              currency={currency}
            />

            {/* Recent transactions */}
            <div className="card border-0 shadow-sm">
              <div className="card-body">
                <RecentTransactions currency={currency} />
              </div>
            </div>
          </div>

          {/* RIGHT: Quick actions + NexumPay */}
          <div className="col-xl-4 mb-3">

             <div className="row">
              <div className="col-12 mb-1">
                <MiniStatCard
                  icon="fa-wallet"
                  label="Actual Bank Balance"
                  value={`${currency} ${numberFormat(quickStats?.actual_amount || 0)}`}
                  tone="primary"
                  meta="Actual"
                  hint="Sum of all cash-at-bank ledger balances."
                  loading={!quickStats}
                />
              </div>

              <div className="col-12 mb-1">
                <MiniStatCard
                  icon="fa-check-circle"
                  label="UnCleared Funds"
                  value={`${currency} ${numberFormat(quickStats?.pending_amount || 0)}`}
                  tone="danger"
                  meta="Pending"
                  hint="Funds not yet cleared by the bank."
                  loading={!quickStats}
                />
              </div>

              <div className="col-12 mb-3">
                <MiniStatCard
                  icon="fa-hourglass-half"
                  label="Provisional Balance"
                  value={`${currency} ${numberFormat(quickStats?.provisional_amount || 0)}`}
                  tone="warning"
                  meta="Available"
                  hint="Balance after reconciliations and pending items."
                  loading={!quickStats}
                />
              </div>
            </div>


            <NexumPaySummaryCard currency={currency} isConnected={false}/>

            <div className="card border-0 shadow-sm mt-1">
              <div className="card-body d-flex flex-column">
                <div className="h6">Quick Actions</div>
                <div className="d-flex flex-wrap" style={{ gap: 8 }}>
               
                  <button className="btn btn-light btn-sm" onClick={handleNewPayment}>
                    <i className="fa fa-random mr-1" />
                    New Payment
                  </button>
                  <button className="btn btn-light btn-sm" onClick={handleReconcile}>
                    <i className="fa fa-balance-scale mr-1" />
                    Reconcile
                  </button>
                  <button className="btn btn-light btn-sm" onClick={handleNewWallet}>
                    <i className="fa fa-university mr-1" />
                    Add Wallet
                  </button>
                </div>


                <div className="mt-3 pt-2 small text-muted">
                  Tips: Reconcile daily to catch discrepancies early.
                </div>
              </div>
            </div>
          </div>
        </div>

      </MainContent>
    </PageContainer>
  );
};

export default NexumPayPage;
